import { Observable } from "rxjs";
import HttpService from "./HttpService";
import { url } from "./APIEndPoints";
import { AuthService, buildParamString, IAPIResponse } from "@mindmemobile/mm-shared-global";
import {
  IAPIContactDetailPageModel,
  IAPIContactGridModel,
  IAPICreateContactModel,
  IAPICreateConteactModel,
  IAPIMindMeContactResponseModel,
} from "../interfaces/IAPIContactModels";

class ContactService {
  private httpService: HttpService;
  constructor() {
    this.httpService = new HttpService(
      undefined,
      `${process.env.REACT_APP_API_KEY}`,
      process.env.REACT_APP_API_BASE_URL
    );
  }

  getContact(
    accountId: string,
    id: string,
    searchValue: string = ""
  ): Observable<IAPIResponse<IAPIContactDetailPageModel>> {
    const params: string = buildParamString({
      accountId: accountId,
      id: id,
      searchValue: searchValue,
    });
    return this.httpService.get<IAPIResponse<IAPIContactDetailPageModel>>(
      url.getContact,
      params
    );
  }

  getContacts(
    accountId: string,
    pageNumber: number,
    pageSize: number,
    searchValue: string
  ): Observable<IAPIResponse<IAPIContactGridModel[]>> {
    const params: string = buildParamString({
      accountId: accountId,
      pageNumber: pageNumber,
      pageSize: pageSize,
      searchValue: searchValue,
    });
    return this.httpService.get<IAPIResponse<IAPIContactGridModel[]>>(
      url.getContacts,
      params
    );
  }

  createContact(
    data: IAPICreateContactModel
  ): Observable<IAPIResponse<IAPICreateConteactModel>> {
    return this.httpService.post<IAPIResponse<IAPICreateConteactModel>>(
      url.createContact,
      data
    );
  }

  updateContact(
    data: IAPICreateContactModel
  ): Observable<IAPIResponse<IAPICreateConteactModel>> {
    return this.httpService.post<IAPIResponse<IAPICreateConteactModel>>(
      url.updateContact,
      data
    );
  }

  deleteContact(accountId: string, id: string): Observable<IAPIResponse<any>> {
    const request = { accountId: accountId, ItemId: id };
    return this.httpService.put<IAPIResponse<any>>(url.deleteContact, request);
  }

  findContact(
    accountId: string,
    mindmeContactId: string
  ): Observable<IAPIResponse<string>> {
    const params: string = buildParamString({
      accountId: accountId,
      mindmeContactId: mindmeContactId,
    });
    return this.httpService.get<IAPIResponse<string>>(url.findContact, params);
  }

  getMindMeContacts(
    accountId: string,
    paymentContactId?: string,
    mindmeContactId?: string,
    searchValue?: string,
    pageSize: number = 50
  ): Observable<IAPIResponse<IAPIMindMeContactResponseModel>> {
    const params: string = buildParamString({
      accountId: accountId,
      paymentContactId: paymentContactId || "",
      mindmeContactId: mindmeContactId || "",
      searchValue: searchValue || "",
      pageSize: pageSize,
    });
    return this.httpService.get<IAPIResponse<IAPIMindMeContactResponseModel>>(
      url.getMindMeContacts,
      params
    );
  }

   checkEmailExistence(
    email: string,
    contactId: string
  ): Observable<IAPIResponse<boolean>> {
    const params: string = buildParamString({
      accountId: AuthService.authData.accountId,
      contactId: contactId,
      email: email,
    });
    return this.httpService.get<IAPIResponse<boolean>>(
      url.checkContactEmailExistence,
      params
    );
  }
}
export default new ContactService();
